import { Component } from '@angular/core';

@Component({
    selector: 'bb-account-number-page-ui',
    template: '',
    styles: [],
    standalone: false,
})
export class BbAccountNumberPageComponent {}
